import { render, staticRenderFns } from "./CoordinateConvert.vue?vue&type=template&id=82b565e8&scoped=true"
import script from "./CoordinateConvert.vue?vue&type=script&lang=js"
export * from "./CoordinateConvert.vue?vue&type=script&lang=js"
import style0 from "./CoordinateConvert.vue?vue&type=style&index=0&id=82b565e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b565e8",
  null
  
)

export default component.exports